export default __webpack_public_path__ + "static/media/653.244f2e79.png";